import { createRoot } from "react-dom/client";
import { setBaseUrl } from "@workspace/api-client-react";
import App from "./App";
import { initFrontendSentry } from "./lib/sentry";
import "./index.css";

// Initialise Sentry as early as possible so it can capture errors from
// the very first render. No-op unless VITE_SENTRY_DSN is set.
initFrontendSentry();

// When the SPA is served from a different origin than the API (e.g. CloudFront
// + S3 in Sydney serving the static bundle, AWS App Runner serving the API at
// api.classtrack.com.au), all generated React Query hooks need to know the API
// origin. In dev / single-origin prod (Replit, classtrack.com.au front+back)
// VITE_API_BASE_URL is unset and requests stay relative to the current origin.
const apiBaseUrl = import.meta.env.VITE_API_BASE_URL;
if (apiBaseUrl) {
  setBaseUrl(apiBaseUrl);
}

// Redirect from the .replit.app domain to the real custom domain.
// Dev preview uses *.replit.dev so this only fires on published deployments.
// The staging deployment and the AU production repl are explicitly excluded
// so smoke-testing can happen on those domains without bouncing to production.
const STAGING_HOSTNAME = "class-track-staging.replit.app";
const AU_PRODUCTION_HOSTNAME = "classtrack-production-au.replit.app";
if (
  window.location.hostname.endsWith(".replit.app") &&
  window.location.hostname !== STAGING_HOSTNAME &&
  window.location.hostname !== AU_PRODUCTION_HOSTNAME
) {
  window.location.replace(
    `https://classtrack.com.au${window.location.pathname}${window.location.search}${window.location.hash}`
  );
} else {
  createRoot(document.getElementById("root")!).render(<App />);
}
